module.exports = __webpack_public_path__ + "static/media/bonus-background.3778c3d7.jpg";